import React, { Component } from 'react';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Notifications, {notify} from 'react-notify-toast';

import BreadcrumbTitle from '../../components/BreadcrumbTitle';
import Incidents from '../components/extraction/Incidents';
import InfoData from '../components/extraction/infoData';
import SangreTotal from '../components/extraction/SangreTotal';
import AvatarInfo from '../components/clinic_history/AvatarInfo';
import Toolbar from '../components/toolbar/Register';
import ButtonForm from '../../components/ButtonForm';

import { donationsId, donationsSave, donationTypeExtractionId, donorHcData, functionalCriterial, getDateHour, incidentsExtractionId, incidentsSave } from '../../libs/services';

import { getFormatHour, isValidForm, showErrors } from '../../libs/functions';
import ModalLiberacion from '../components/extraction/ModalLiberacion';
import Apheresis from '../components/extraction/Apheresis';
import ProcessData from '../components/extraction/ProcessData';
import LabelForm from '../../components/LabelForm';

class ExtractionForm extends Component{
    constructor(props){
        super(props);

        this.calculateExpiration = this.calculateExpiration.bind(this);
        this.deleteDonationNumber = this.deleteDonationNumber.bind(this);
        this.generateUnitAF = this.generateUnitAF.bind(this);
        this.generateUnitST = this.generateUnitST.bind(this);
        this.getAF = this.getAF.bind(this);
        this.getST = this.getST.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onSave = this.onSave.bind(this);
        this.saveIncidentsExtraction = this.saveIncidentsExtraction.bind(this);
        this.setDoubleUnits = this.setDoubleUnits.bind(this);
        this.updateUnits = this.updateUnits.bind(this);
        this.updateUnitsAF = this.updateUnitsAF.bind(this);
        this.updateFields = this.updateFields.bind(this);
        
        this.state = {
            can_edit: true,
            donation_id:'',
            donation_number:"",
            donation_type:"",
            donor_number:'',
            extraction_type:'',
            extraction:{
                date:'',
                hour:'',
                medical_staff_id:'',
                arm:'',
                tube:'0',
                bag_flag:'1',
                blood_bags_id:'',
                extraction_time:'',
                volume:'',
                equipment_id:'',
                lote_number:'',
                lote_number_local:'',
                type:'',
                crio_preserved:'',
                picking:'',
                lote_anticuagulant:'',
                volume_anticoagulant:'',
                cycle_number:'',
                processed_blood:'',
                start_hour:'',
                end_hour:'',
                apheresis_kits_id:'',
                platelet_performance:'',
                equivalent_units:'',
                equivalent_units_double:'',
                proceced_blood:''
            },
            error_date:'',
            error_hour:'',
            et_id:'',
            form:'',
            incident_id:'',
            person:{
                id:'',
                fullName:'',
                birthday:'',                
                age:'',
                sex:'',
                document_type:'',
                document_number:'',
                date:'',
                convokePlace:'',
                photo:'',
                person_id:'',
                donor_id:''
            },        
            proc_ext_ce:{},
            proc_ext_plasma:{},
            proc_ext_plaq:{},
            saved:false,
            units:[],
            valid_days:true,
            doubleUnits:false,
            show_process:false,
            fields:[
				{label:'Recuento de Plaquetas', id:'platelet_count', value:''},
				{label:'Código de kit', id:'kit_code', value:''},
				{label:'% de Plasma', id:'plasma_percentage', value:''},
				{label:'Vol. AC Producto', id:'anticoagulant_product_volume', value:''},
				{label:'Vol. de Sol. Aditiva', id:'additive_solution_volume', value:''},
				{label:'Vol. AC Donador', id:'anticoagulant_donor_volume', value:''},
				{label:'Rendimiento', id:'performance', value:''},
				{label:'Lote Sol. Aditiva', id:'additive_solution_lot', value:''},
				{label:'Hematocrito', id:'hematocrit', value:''},
				{label:'VTS', id:'total_blood_volume', value:''},
				{label:'Recuento Post Donación', id:'post_donation_count', value:''},
				{label:'Hematocrito Post', id:'post_hematocrit', value:''}
            ],
            show_af_data_int:{}
        }
    }

    async componentDidMount(){
        var id = this.props.match.params.id;
        var type = this.props.match.params.type;
        var donation_id = parseInt(this.props.match.params.donation_id);
        console.log(this.props.match);

        await this.props.waiting.handleShow('Cargando...');

        var response = functionalCriterial('PROC_EXT_CE');
		if(response){
			this.setState({
				proc_ext_ce: response
			});
		}
		
		response = await functionalCriterial('PROC_EXT_PLASMA');
		if(response){
			this.setState({
				proc_ext_plasma: response
			});
		}
		
		response = await functionalCriterial('PROC_EXT_PLAQ');
		if(response){
			this.setState({
				proc_ext_plaq: response
			});
		}

        response = await functionalCriterial('SHOW_AF_DATA_INT');
		if(response){
			this.setState({
				show_af_data_int: response
			});
		}

        response = await donorHcData(id, type);
        if(response){
            var person = {
                id:response.id,
                fullName:response.lastnames+' '+response.names,
                birthday:moment(response.birthday).format('DD/MM/YYYY'),
                age:response.age,
                sex:response.sex,
                document_type:response.document_type,
                document_number:response.document_number,
                convokePlace:response.convoke_place,
                photo: response.photo !== null ? response.photo : '',
                person_id:response.person_id,
                donor_id:response.donor_id,
                date:response.register_date !== null ?  moment(response.register_date).format('DD/MM/YYYY')+ (response.register_hour !== null ? moment(response.register_hour).format('HH:mm') : '') : ''
            };

            var form = response.extraction_type === 'SANGRE TOTAL' || response.extraction_type === 'SANGRE PLACENTARIA' || response.extraction_type === 'MÉDULA ÓSEA' ? 'ST' : 'AF';
            
            await this.setState({
                person:person,
                donation_type:response.donation_type,
                extraction_type:response.extraction_type !== null ? response.extraction_type : '',
                donor_number:response.donor_number,
                et_id:response.extraction_type_id,
                form:form
            });

            if(form === 'ST'){
                await this.sangre_total.getBloodBags(response.extraction_type_id);
            }else{
                await this.apheresis.getApheresisKits(response.extraction_type_id);
            }
            
            
        }

        response = await getDateHour();
        if(response){
            var aux = response.split('|');			
            var hours = getFormatHour(aux[1]);

            var extraction = this.state.extraction;
            extraction = {
                ...extraction,
                date:aux[0],
                hour:hours
            }

            this.setState({
                extraction: extraction
            });
        }

        response = await donationTypeExtractionId(this.state.et_id);
        if(response){
            var extraction = this.state.extraction;
            extraction = {
                ...extraction,
                volume:response.donation_type_extraction.volumen_default !== null ? response.donation_type_extraction.volumen_default : '',
                type:response.donation_type_extraction.code
            };

            this.setState({extraction:extraction});
        }

        if(donation_id !== 0){
            response = await donationsId(donation_id);
            console.log("response", response)
            if(response){
                
                await this.setState({
                    can_edit:response.can_be_edit,
                    donation_id:response.donation.id,
                    donation_number: response.donation.donation_number,      
                    fields:response.other_data,          
                    extraction:{
                        ...extraction,
                        arm: response.donation.arm !== null ? response.donation.arm : '',
                        bag_flag: response.donation.bag_flag !== null ? response.donation.bag_flag : this.state.extraction.bag_flag,
                        blood_bags_id: response.donation.blood_bags_id !== null ? response.donation.blood_bags_id : '',
                        crio_preserved: response.donation.crio_preserved !== null ? response.donation.crio_preserved : '',
                        equipment_id: response.donation.equipment_id !== null ? response.donation.equipment_id : '',
                        extraction_time: response.donation.extraction_time !== null ? response.donation.extraction_time : '',
                        lote_number_local: response.donation.local_number !== null ? response.donation.local_number : '',
                        lote_number: response.donation.lote_number !== null ? response.donation.lote_number : '',
                        date: response.donation.timestamp_date !== null ? moment(response.donation.timestamp_date).format('DD/MM/YYYY') : this.state.extraction.date,
                        hour: response.donation.timestamp_hour !== null ? moment(response.donation.timestamp_hour, 'HH:mm:ss').format('HH:mm') : this.state.extraction.hour,
                        tube: response.donation.tube !== null ? response.donation.tube : this.state.extraction.tube,
                        medical_staff_id: response.donation.users_id !== null ? response.donation.users_id : '',
                        volume: response.donation.volume !== null ? response.donation.volume : this.state.extraction.volume,
                        picking: response.donation.picking !== null ? response.donation.picking : '',
                        lote_anticuagulant: response.donation.lote_anticuagulant,
                        volume_anticoagulant: response.donation.volume_anticoagulant,
                        cycle_number: response.donation.cycle_number,
                        processed_blood: response.donation.proceced_blood,
                        start_hour: response.donation.time_start !== null ? moment(response.donation.time_start).format('HH:mm') : '',
                        end_hour:response.donation.time_end !== null ? moment(response.donation.time_end).format('HH:mm') : '',
                        apheresis_kits_id:response.donation.apheresis_kits_id,
                        proceced_blood: response.donation.proceced_blood,
                        number_cells: response.donation.number_cells
                    },
                    incident_id:response.incident_id !== 0 ? response.incident_id : '',
                    person:{
                        ...person,
                        date: moment(response.created_at).format('DD/MM/YYYY HH:mm')
                    },
                    doubleUnits:response.donation.apheresis_double
                });

                if(this.state.form === 'AF'){
                    await this.setUnitsAF(response.donation.apheresis_kits_id, response);
                }else{
                    this.setState({units:response.unit});
                }

                if(response.incident_id !== 0){
                    response = await incidentsExtractionId(response.incident_id);
                    if(response){
                        response.incident_ids.forEach(async (incident)=>{
                            await this.incidents.setIncidents(incident);
                        });                        
                    }
                }                
            }

        }

        await this.props.waiting.handleClose();
    }

    calculateExpiration(dias){
		var date = moment(this.state.extraction.date, 'DD/MM/YYYY');
		date = date.format('MM-DD-YYYY');

		var fecha = new Date(date);

		fecha.setDate(fecha.getDate() + parseInt(dias));

		var caducidad = fecha.getDate()+'/'+(fecha.getMonth() + 1)+'/'+fecha.getFullYear();
		caducidad = moment(caducidad, 'DD-MM-YYYY');

		return caducidad.format('MM-DD-YYYY');
	}

    deleteDonationNumber(){
        this.modal_liberacion.handleShow(this.state.donation_id)
        //this.modal_liberation.handleShow(this.state.donation_id);
    }

    generateUnitAF(value){
        var units = this.state.units;
    
        if(units.length === 0){
            var apheresis = this.apheresis.state.apheresis;
            var index = apheresis.findIndex(obj => obj.id === parseInt(value));
            if(index !== -1){
                
                var assigned = apheresis[index].asigned_components.asigned;
                var components = apheresis[index].asigned_components.components;
                var unit1, unit2;
                units = components.map((comp, i)=>{
                    unit1 = {
                        show:true,
                        donation_id:this.state.donation_id,
                        blood_component_id: assigned[i].blood_component_id, 
                        volume:"",
                        current_unit:true,
                        unit_number: this.state.donation_number,
                        caducidad: this.calculateExpiration(assigned[i].expiration_days),
                        rendimiento:"",
                        equivalente:"",
                        flag: assigned[i].flag_platelets_units !== null ? assigned[i].flag_platelets_units : false,
                        health_facilities_id:sessionStorage.getItem('health_facilities_id'),
                        equivalent_and_platelet_performance:[]
                    };

                    unit2 = unit1;

                    var obj = {
                        index:i,
                        component_name: comp.component,
                        units:[
                            unit1, 
                            {...unit2, show:this.state.doubleUnits}
                        ],
                    };
              
                    return obj;
                });

                this.setState({units:units});
            }
        }
    }

    setUnitsAF(id, response){
        var units = [];
        var apheresis = this.apheresis.state.apheresis;
        var index = apheresis.findIndex(obj => obj.id === parseInt(id));
        if(index !== -1){
            var assigned = apheresis[index].asigned_components.asigned;
            var components = apheresis[index].asigned_components.components;

            components.forEach((component, c)=>{
                var obj = {
                    component_name: component.component,
                    units:[]
                }

                response.unit.forEach((unit, i)=>{
                    unit.show = i === 0 ? true : response.donation.apheresis_double;
                    unit.rendimiento = '';
                    unit.equivalente = '';
                    unit.flag = assigned[c].flag_platelets_units !== null ? assigned[c].flag_platelets_units : false;
                    unit.equivalent_and_platelet_performance = [];

                    response.equivalent_and_platelet_performance.forEach((performance)=>{
                        if(unit.id === performance.unit_id && performance.bag_number === (i+1)){
                            unit.rendimiento = performance.platelet_performance;
                            unit.equivalente = performance.equivalent_units;
                        }
                    });                   
                    
                    obj.units.push(unit);
                });

                units.push(obj);
            });

            this.setState({units:units});
        }
    }

    generateUnitST(value){
        var units = this.state.units;
        if(units.length === 0){
            var blood_bags = this.sangre_total.state.blood_bags;                    
            var index = blood_bags.findIndex(item => item.id === parseInt(value));
            if(index !== -1){
                var item = {
                    donation_id: this.state.donation_id,
                    blood_component_id: blood_bags[index].blood_component_default_id,
                    volume:this.state.extraction.volume,
                    current_unit:true,
                    unit_number:this.state.donation_number,
                    component_number:'00',
                    caducidad:this.calculateExpiration(blood_bags[index].expiration_days),
                    health_facilities_id:sessionStorage.getItem('health_facilities_id')
                };

                units = [item];
            }                   
        }

        this.setState({units:units});
    }

    getST(){
        var type = this.props.match.params.type;
        var id = this.props.match.params.id;
        var donation_id = parseInt(this.state.donation_id);
        
        var donation = {
            id: donation_id,
            timestamp_date:  moment(this.state.extraction.date, 'DD/MM/YYYY').format('MM-DD-YYYY'),
            timestamp_hour: moment(this.state.extraction.hour, 'HH:mm').format('H:mm'),
            donation_number: this.state.donation_number,
            users_id: this.state.extraction.medical_staff_id !== '' ? parseInt(this.state.extraction.medical_staff_id) : null,
            tube: parseInt(this.state.extraction.tube,10),
            arm: this.state.extraction.arm,
            extraction_time: this.state.extraction.extraction_time,
            volume: parseInt(this.state.extraction.volume,10),
            bag_flag: parseInt(this.state.extraction.bag_flag,10),
            equipment_id:this.state.extraction.equipment_id,
            blood_bags_id: parseInt(this.state.extraction.blood_bags_id,10),
            lote_number: this.state.extraction.lote_number !== "" ? this.state.extraction.lote_number : null,
            local_number: this.state.extraction.lote_number_local !=="" ? this.state.extraction.lote_number_local : null,
            incidents_ids: this.incidents.getIncidents(),
            unit:this.state.units,
            crio_preserved:this.state.extraction.crio_preserved,
            picking:this.state.extraction.picking
        };

        if(type === 'CELLS'){
            donation.offering_cell_id = id;
        }        

        return donation;        
    }

    getAF(){
        var donation = {
            id: this.state.donation_id,
            //offers_id = parseInt(this.props.match.params.offers_id,10),
            donation_number: this.state.donation_number,
            users_id: this.state.extraction.medical_staff_id,
            tube: parseInt(this.state.extraction.tube,10),
            bag_flag: parseInt(this.state.extraction.bag_flag,10),
            arm: this.state.extraction.arm,
            equipment_id: this.state.extraction.equipment_id !== ""? parseInt(this.state.extraction.equipment_id,10) : null,
            timestamp_date:  moment(this.state.extraction.date, 'DD/MM/YYYY').format('MM-DD-YYYY'),
            timestamp_hour: moment(this.state.extraction.hour, 'HH:mm').format('H:mm'),
            time_start: this.state.extraction.start_hour.indexOf('-') !== -1 ? "" : this.state.extraction.start_hour,
            time_end: this.state.extraction.end_hour.indexOf('-') !== -1 ? "" : this.state.extraction.end_hour,
            cycle_number: this.state.extraction.cycle_number,
            apheresis_kits_id: parseInt(this.state.extraction.apheresis_kits_id,10),
            lote_number: this.state.extraction.lote_number,
            volume_anticoagulant: this.state.extraction.volume_anticoagulant !=="" ? parseInt(this.state.extraction.volume_anticoagulant,10) : null,
            lote_anticuagulant: this.state.extraction.lote_anticuagulant,
            local_number: this.state.extraction.lote_number_local !=="" ? this.state.extraction.lote_number_local : null,
            platelet_performance: this.state.extraction.platelet_performance,
            equivalent_units:  this.state.extraction.equivalent_units !=="" ? parseInt(this.state.extraction.equivalent_units,10) : null,
            incidents_ids: this.incidents.getIncidents(),
            proceced_blood: this.state.extraction.processed_blood !== "" ? parseInt(this.state.extraction.processed_blood, 10) : null,
            apheresis_double: this.state.doubleUnits,
            crio_preserved:this.state.extraction.crio_preserved,
            picking:this.state.extraction.picking
        };
		
		if(this.state.doubleUnits){
			donation.equivalent_units_double = this.state.equivalent_units_double !== "" ? parseInt(this.state.equivalent_units_double, 10)	: null;
		}

        var units = [];
        this.state.units.forEach((unit)=>{
            unit.units.forEach((item, i)=>{
                item.component_number= this.state.doubleUnits ? i === 0 ? 'A0' : 'B0' : '00';

                if(item.volume !== "" && (item.rendimiento !== "" || item.equivalente !== "")){
                    item.equivalent_and_platelet_performance.push({
                        platelet_performance: item.rendimiento, 
                        equivalent_units: item.equivalente === "" ? null : item.equivalente, 
                        bag_number: (i+1)
                    })
                };

                if(item.show){
                    units.push(item);
                }
                
            });
        });

        donation.unit = units;

        return donation;
    }

    async handleChange(e, variables = {type:''}){
        let {name, value} = e.target;
        if(variables.type === 'obj'){
            var obj = this.state[variables.name];
            if(name !== 'volume'){
                obj = {
                    ...obj,
                    [name]:value
                }
            }

            if(name === 'apheresis_kits_id' && value !== ""){
                this.generateUnitAF(value);
            }

            if(name === 'blood_bags_id' && value !== ""){
                this.generateUnitST(value);
            }

            if(name === 'date'){
                if(value.indexOf('_') === -1 || value === ''){
                    this.setState({error_date:''});

                }else{
                    this.setState({error_date:'Fecha no valida'});
                }
            }

            if(name === 'hour'){
                if(value.indexOf('-') === -1 || value === ''){
                    this.setState({error_hour:''});
                }else{
                    this.setState({error_hour:'Hora no valida'});
                }
            }

            if(name === 'volume'){
                if(value === ""){
                    obj = {
                        ...obj,
                        [name]:value
                    }  
                }
                if(value.length < 4){
                    let regex = new RegExp("^[0-9]+$");
        
                    if(regex.test(value)){
                        obj = {
                            ...obj,
                            [name]:value
                        }
                    }					
                }

                this.updateUnits(name, value);
            }

            this.setState({[variables.name]: obj});

        }else{
            await this.setState({[name]: name === 'doubleUnits' ? e.target.checked : value});

            if(name === 'donation_id' || name === 'donation_number'){
                if(this.state.form === 'ST'){
                    await this.updateUnits(name, value);
                }else{
                    await this.updateUnitsAF(e, {name:name});
                }
                
            }
            
            if(name === 'doubleUnits'){                
                await this.setDoubleUnits();
            }
        }
        
    }

    onCancel(){
        this.props.history.goBack();
    }

    async onSave(){
        var errors = [];

        if(this.state.donation_number === ""){
            errors.push('No se ha generado el número de donación');
        }

        if(!isValidForm('div.extraction-form')){
            errors.push('Campos incompletos');
        }

        if(this.state.error_date !== ''){
            errors.push(this.state.error_date);
        }

        if(this.state.error_hour !== ''){
            errors.push(this.state.error_hour);
        }

        var now_date = moment().format('YYYY-MM-DD');
        var beginningDate = moment(now_date);
        if(this.state.extraction.date !== ''){
            var endDate = moment(this.state.extraction.date, 'DD/MM/YYYY');

            if(beginningDate < endDate){
                errors.push('La fecha no puede ser mayor a fecha actual');
            }
        }

        var now_time = moment().format('HH:mm');
        var beginningTime = moment(now_time, 'h:mma');
        if(this.state.extraction.hour !== ''){
            var endTime = moment(this.state.extraction.hour, 'h:mma');

            if(beginningTime.isBefore(endTime)){
                errors.push('La hora no puede ser mayor a hora actual');
            }
        }

        var obj = this.state.form === 'ST' ? this.getST() : this.getAF();

        if(errors.length === 0){
            var response = await donationsSave(obj.id, obj, this.props.waiting);
            if(response){
                if(this.incidents.state.incidents.length > 0){
                    await this.saveIncidentsExtraction(this.incidents.state.incidents);
                }else{
                    notify.show('Registro Guardado','success');
    		        setTimeout(()=>{
                        this.props.history.goBack();
                    }, 1500);
                    
                }
            }
            

            
        }else{
            showErrors(errors);
        }
    }

    async saveIncidentsExtraction(incidents){
        var type = this.props.match.params.type;
        var id = this.props.match.params.id;
        var incident_id = this.state.incident_id;
        
        var obj = {
            manifestation_ids:[],
            moment_incident:'moment_during',
            incident_ids:[],
            timestamp_date:moment(this.state.extraction.date, 'DD/MM/YYYY').format('MM-DD-YYYY'),
            timestamp_hour:moment(this.state.extraction.hour, 'HH:mm').format('H:mm') 
        }

        if(type === 'CELLS'){
            obj.offering_cell_id = id;
        }

        obj.incident_ids = incidents.map((incident)=>{
            return incident.id;
        });

        if(obj.incident_ids.length > 0){
            var response = await incidentsSave(incident_id, obj, this.props.waiting);
            if(response){
                //revisar extraccion para servicio caller
                notify.show('Registro Guardado','success');
                setTimeout(()=>{
                    this.props.history.goBack();
                }, 1500);
            }
        }
    }

    setDoubleUnits(){
        var units = this.state.units;
        if(units.length > 0){
            units.forEach(unit => {
                unit.units.forEach((item, i)=>{
                    if(i > 0){
                        item.show = this.state.doubleUnits;
                    }
                });
            });

            this.setState({units});
        }
    }

    updateUnits(name, value){
        var units = this.state.units;
        if(name === 'donation_number'){
            name = 'unit_number';
        }
        if(units.length > 0){
            units.forEach((u)=>{
                
                if(name === 'volume'){
                    if(value === ""){
                        u[name] = value;
                    }
                    if(value.length < 4){
                        let regex = new RegExp("^[0-9]+$");
            
                        if(regex.test(value)){
                            u[name] = value;
                        }					
                    }
                }else{
                    u[name] = value;
                }

            });

            this.setState({units});
        }        
    }

    updateUnitsAF(e, variables){
        let {value} = e.target;
        let {name, index, unit} = variables;
        var units = this.state.units;

        if(name === 'volume'){
            units[index].units[unit][name] = value.length > 4 ? units[index].units[unit][name] : value;
        }
        if(name === 'rendimiento'){
            units[index].units[unit][name] = value.length > 50 ? units[index].units[unit][name] : value;
        }
        if(name === 'equivalente'){
            units[index].units[unit][name] = value.length > 1 ? units[index].units[unit][name] : value;
        }

        if(name === 'donation_id' || name === 'donation_number'){
            if(name === 'donation_number'){
                name = 'unit_number';
            }
            units.forEach(unit => {
                unit.units.forEach((item)=>{
                    item[name] = value;
                });
            });
        }

        this.setState({units:units});
    }

    verifyTimes(){
        var val1 = parseInt(this.state.proc_ext_ce.value);
        var val2 = parseInt(this.state.proc_ext_plasma.value);
        var val3 = parseInt(this.state.proc_ext_plaq.value);
        
        var min = Math.min(val1, val2, val3);
        
        //var verify = this.state.extraction.type === 'ST' || 

        if(this.state.extraction.hour !== ""){
            var time = parseInt(this.state.extraction.hour);

            if(time > min){
                var dif = time - min;

                swal({
                    title:'Alerta',
                    text:'Esta extracción se excede por '+dif+' minutos de tiempo de extracción '+
                        'lo cual puede provocar que esta unidad no pueda ser fraccionada.'+
                        ' Desea Continuar?',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: '¡Si, Continuar!',
                    cancelButtonText: '¡No, Cancelar!',
                    closeOnConfirm: true,
                    closeOnCancel: true,
                }, (isConfirm)=>{
                    if(isConfirm){
                        this.onSave();
                    }                    
                });
            }else{
                this.onSave();
            }
        }
    }

    updateFields(e, i){
        var fields = this.state.fields;
		
		fields[i].value = e.target.value;

		this.setState({fields: fields});
    }

    render(){
        const {t} = this.props;
        return(
            <div className='col-xs-12 no-padding'>
                <BreadcrumbTitle 
                    menu="Donación"
                    page="Banco de Células -> Extracción"
                />

                <div className="col-xs-12 form-group status-bar extraction-bar">
                    <label>{"EXTRACCIÓN "+this.state.extraction_type}</label>
                </div>
                <div className='col-xs-12 no-padding'>
                    <div className='col-xs-12 col-sm-9'>
                        <div className='col-xs-12 no-padding extraction-form'>
                            <div className='col-xs-12 col-sm-10 col-sm-offset-2'>
                                <div className='col-xs-12 no-padding'>
                                    <InfoData 
                                        {...this.props}
                                        person={this.state.person}
                                        donation_number={this.state.donation_number}
                                        handleChange={this.handleChange}
                                        deleteNumber={this.deleteDonationNumber}
                                    />
                                </div>
                                
                                <div className='col-xs-12 no-padding'>
                                    {this.state.form === 'ST' ?
                                        <SangreTotal 
                                            {...this.props}
                                            handleChange={this.handleChange}
                                            extraction={this.state.extraction}
                                            error_date={this.state.error_date}
                                            error_hour={this.state.error_hour}
                                            can_edit={!this.state.can_edit}
                                            onRef={ref => this.sangre_total = ref}
                                        />
                                    :
                                        <Apheresis 
                                            {...this.props}
                                            handleChange={this.handleChange}
                                            updateUnitsAF={this.updateUnitsAF}
                                            setDoubleUnits={this.setDoubleUnits}
                                            extraction={this.state.extraction}
                                            error_date={this.state.error_date}
                                            error_hour={this.state.error_hour}
                                            can_edit={!this.state.can_edit}
                                            units={this.state.units}
                                            doubleUnits={this.state.doubleUnits}
                                            onRef={ref => this.apheresis = ref}
                                        />
                                    }
                                    
                                </div>
                                
                                {(this.state.show_af_data_int.value === 'YES' && this.state.form === 'AF') &&
                                    <div className='col-xs-12 form-group' style={{paddingTop:15, paddingLeft:0}}>
                                        <hr/>
                                        {this.state.fields.length > 0 &&
                                            <ProcessData {...this.props} fields={this.state.fields} updateFields={this.updateFields} />
                                        }
                                    </div>
                                }

                                <div className='col-xs-12 no-padding'>
                                    <Incidents 
                                        {...this.props}                                     
                                        can_edit={!this.state.can_edit}
                                        onRef={ref => this.incidents = ref}
                                        disabled={!this.state.can_edit}
                                    />
                                </div>
                                
                            </div>
                        </div>
                        
                    </div>
                    <div className='col-xs-12 col-sm-3'>
                        <AvatarInfo 
                             person={this.state.person}
                             donation_type={this.state.donation_type}
                             extraction_type={this.state.extraction_type}
                             donor_number={this.state.donor_number}
                             historyBtn={false}
                             editBtn={true}
                        />
                    </div>
                </div>

                

                <div className="col-xs-12 form-group">
                    <Toolbar
                        {...this.props}
                        variables={{
                            donation_id:this.state.donation_id,
                            label:{
                                extraction:{
                                    file_type:'label_extraction',
                                    id: this.state.donation_id,
                                    extraction: this.state.extraction_type,
                                    direct:false,
                                    option:'print',
                                    traceability:true,
                                    reference_id: this.props.match.params.id
                                }
                            }
                        }}
                        disabled={this.state.donation_number === ""}
                        printApheresis={this.state.form === 'AF'}
                        labelExtraction={true}
                        labelPrevBag={false}
                        notes={false}
                        suppliesBtn={false}
                        extractionSamples={false}
                        reportExtraction={true}
                        onRef={ref => this.toolbar = ref}
                    />
                </div>
                <div className="col-xs-12 form-group" style={{textAlign:'center'}}>
                    {!this.state.saved?
                        <>
                            <ButtonForm 
                                label={t('content.generics.buttons.save')} 
                                action={this.onSave}
                            />
                            <ButtonForm 
                                label={t('content.generics.buttons.reset')} 
                                action={this.onCancel}
                            />
                        </>
                    :
                        <>
                            <ButtonForm 
                                label={t('content.generics.buttons.finish')} 
                                action={this.onCancel}
                            />
                        </>	
                    }
                </div>

                <Notifications />
                <ModalLiberacion {...this.props} onRef={ref => (this.modal_liberacion = ref)} />
            </div>
        )
    }
}

export default translate('translations') (ExtractionForm);